import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./AddPurchase.css";

const EditStaffAttendance = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    department: "",
    date: "",
    time: "",
    action: "Check-in",
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    // TODO: Fetch data from API using id
    console.log("Editing attendance ID:", id);
    // Example: axios.get(`/api/attendance/${id}`).then(res => setFormData(res.data));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const map = `https://maps.google.com/?q=${formData.latitude},${formData.longitude}`;
    const updatedEntry = { id, ...formData, map };

    console.log("Updated Attendance Entry:", updatedEntry);
    // TODO: Send update to backend
    navigate("/staffattendance");
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Edit Staff Attendance</h4>
        <button className="btn-top" onClick={() => navigate(-1)}>Back</button>
      </div>

      <form onSubmit={handleSubmit} noValidate>
        <div className="row g-3">
          {[
            { label: "Name", name: "name", type: "text" },
            { label: "Designation", name: "designation", type: "text" },
            { label: "Department", name: "department", type: "text" },
            { label: "Date", name: "date", type: "date" },
            { label: "Time", name: "time", type: "time" },
            { label: "Latitude", name: "latitude", type: "text" },
            { label: "Longitude", name: "longitude", type: "text" },
          ].map(({ label, name, type }) => (
            <div className="col-lg-4 col-md-6 col-sm-12" key={name}>
              <label className="form-label">{label}</label>
              <input
                type={type}
                className="form-control"
                name={name}
                value={formData[name]}
                onChange={handleChange}
              />
            </div>
          ))}

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Action</label>
            <select
              className="form-control"
              name="action"
              value={formData.action}
              onChange={handleChange}
            >
              <option value="Check-in">Check-in</option>
              <option value="Check-out">Check-out</option>
            </select>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <button type="submit" className="btn-submit">Update</button>
          <button type="button" className="btn-cancel" onClick={() => navigate(-1)}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default EditStaffAttendance;
